import { useEffect, useState } from "react";
import { toast } from "sonner";
import { http } from "../../lib/api";
import { can, useAuth } from "../../lib/auth";
import { Btn, Card } from "../kit/Kit";
import { mxn, sel } from "./common";
import { OpDetalle } from "./OpDetalle";

const PLAZOS = ["Vista", "7 días", "14 días", "28 días", "90 días", "91 días", "180 días", "360 días"];
const VACIO = { nombre: "", tipo: "PF", monto: "", plazo: "28 días", tasa: "", instruccion: "Sin dato" };

const Nueva = ({ onDone }) => {
  const [f, setF] = useState(VACIO);
  const set = (k) => (e) => setF({ ...f, [k]: e.target.value });
  const guardar = () => http.post("/captacion/pipeline", { ...f, monto: Number(f.monto), tasa: f.tasa === "" ? null : Number(f.tasa) })
    .then(() => { toast.success("Oportunidad creada"); setF(VACIO); onDone(); }).catch((e) => toast.error(typeof e.response?.data?.detail === "string" ? e.response.data.detail : "Revisa los datos"));
  return (
    <div className="grid grid-cols-2 gap-2 md:grid-cols-7" data-testid="cap-op-nueva">
      <input value={f.nombre} onChange={set("nombre")} placeholder="Nombre del ahorrador" className={`${sel} col-span-2`} data-testid="cap-op-nombre" />
      <select value={f.tipo} onChange={set("tipo")} className={sel} data-testid="cap-op-tipo">{["PF", "PFAE", "PM"].map((x) => <option key={x}>{x}</option>)}</select>
      <input type="number" value={f.monto} onChange={set("monto")} placeholder="Monto" className={sel} data-testid="cap-op-monto" />
      <select value={f.plazo} onChange={set("plazo")} className={sel} data-testid="cap-op-plazo">{PLAZOS.map((x) => <option key={x}>{x}</option>)}</select>
      <input type="number" step="0.01" value={f.tasa} onChange={set("tasa")} placeholder="Tasa (vacío = tabla)" className={sel} data-testid="cap-op-tasa" />
      <select value={f.instruccion} onChange={set("instruccion")} className={sel} data-testid="cap-op-instruccion">{["Sin dato", "Reinvertir", "Liquidar"].map((x) => <option key={x}>{x}</option>)}</select>
      <Btn onClick={guardar} data-testid="cap-op-guardar">Crear</Btn>
    </div>
  );
};

const Tarjeta = ({ o, onOpen }) => (
  <button onClick={onOpen} className="w-full rounded-lg border border-[#E2DDD5] bg-white p-2 text-left text-xs transition-colors hover:border-[#E8643C]" data-testid={`cap-op-${o.id}`}>
    <p className="truncate font-medium">{o.nombre}</p>
    <p>{o.tipo} · {mxn(o.monto)} · {o.plazo || "—"} · {o.tasa ?? "—"}%</p>
    {o.fuera_tabla && <span className="rounded bg-amber-100 px-1 text-[10px] text-amber-900">fuera de tabla · {o.aprob_estado || "sin enviar"}</span>}
  </button>
);

export const CapPipeline = () => {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [qa, setQa] = useState(false);
  const [sel_, setSel] = useState(null);
  const load = () => http.get("/captacion/pipeline", { params: { qa } }).then((r) => setD(r.data));
  useEffect(() => { load(); }, [qa]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d) return null;
  const upd = (o) => { setSel(o); load(); };
  return (
    <div className="space-y-4" data-testid="cap-pipeline">
      <p className="text-xs text-[#5C5850]" data-testid="cap-pipeline-regla">{d.config.regla}{d.config.umbral_nota && ` Umbral del Director: ${d.config.umbral_nota}.`}</p>
      <div className="flex flex-wrap items-center gap-3">
        <label className="flex items-center gap-2 text-xs"><input type="checkbox" checked={qa} onChange={(e) => setQa(e.target.checked)} data-testid="cap-pipeline-qa" />Incluir QA</label>
        {["master", "admin"].includes(user?.template) && <Btn kind="ghost" onClick={() => http.delete("/captacion/qa/fixture").then((r) => { toast.success(`Datos QA eliminados (${r.data.cap_oportunidades} prospectos)`); load(); })} data-testid="cap-qa-eliminar">Eliminar datos QA</Btn>}
      </div>
      {can(user, "captacion.gestionar") && <Card title="Nueva oportunidad"><Nueva onDone={load} /></Card>}
      <div className="flex gap-3 overflow-x-auto pb-2" data-testid="cap-kanban">
        {d.etapas.map((e) => { const xs = d.items.filter((o) => o.etapa === e); return (
          <div key={e} className="w-56 shrink-0 space-y-2 rounded-xl bg-[#F7F5F1] p-2" data-testid={`cap-col-${e}`}>
            <p className="text-xs font-semibold uppercase tracking-wide text-[#5C5850]">{e} · {xs.length}</p>
            {xs.map((o) => <Tarjeta key={o.id} o={o} onOpen={() => setSel(o)} />)}
          </div>); })}
      </div>
      <OpDetalle op={sel_} onClose={() => setSel(null)} onChange={upd} />
    </div>
  );
};
